import { injectReducer } from 'ducks/configureStore';
import {
  Feature,
  RenderLocation,
  RendersComponent,
  ShouldReset
} from '../../../../features/Feature';
import EkrisControls from './EkrisControls';
import { EkrisGame } from './EkrisGame';
import { CoreApi } from '@inter-ikea-storageone/range';
import { ekrisReducer, EkrisState, endGame } from './ekrisReducer';
import { Dispatch } from 'redux';
export class EkrisFeature extends Feature implements RendersComponent, ShouldReset {
  private game: EkrisGame | null = null;

  protected init(coreApi: CoreApi): void {
    injectReducer<EkrisState>('ekris', ekrisReducer);
    this.game = new EkrisGame(coreApi);
  }

  getGame(): EkrisGame | null {
    return this.game;
  }

  render(location: RenderLocation) {
    if (location !== RenderLocation.Root) return;
    return EkrisControls;
  }

  reset(dispatch: Dispatch): void {
    this.game?.stopGame();
    dispatch(endGame());
  }
}

export * from './ekrisReducer';
